const selectors = {
    el: '.js-sticky:not(.is-initialized)'
}

const calcPageHeight = (el) => {
    const main = document.querySelector('main');
    const pageHeight = main.offsetHeight + main.offsetTop - el.offsetTop;
    el.style.setProperty('--pageH', `${pageHeight}px`);
};

const init = () => {
    const els = document.querySelectorAll(selectors.el);
    els.forEach(el => {
        el.classList.add('is-initialized');

        calcPageHeight(el);
        window.addEventListener('resize', () => calcPageHeight(el));
    });
};

const module = () => {
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('domUpdated', init);
};

export default module;